// extracted by mini-css-extract-plugin
module.exports =  {"SearchKeywords":"SearchKeywords__Whd3r","tableBlock":"tableBlock__SDzu-"};